import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

// COMPONENTS
import VertCardProductContainer from 'components/VertCardProductContainer/VertCardProductContainer';

// DS
import { VertCarousel, VertContainer, Row, Col, VertTypography, VertButton } from '@vertem-core/vertice-ds';

// SERVICES
import PipeProvider from 'Services/Providers/PipeProvider';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';

// UTILS
import generateUUID from 'Utils/generateUUID';
import getShowcaseState from 'Utils/getShowcaseItems';
import { stringToSlug } from 'Utils/stringToSlug';
import { ShowcaseCard } from 'components/ShowcaseProduct/ShowcaseCard';

// SHOCASE VOUCHER WRAPPER
const ShowcaseVoucherWrapper = ({
  children, title, mobileTitle, type, identifier, hideShowAll,
}) => {
  const [showArrows, setShowArrows] = useState(true);

  useEffect(() => {
    const slidesToShow = settings.slidesToShow;
    const isFewerItems = children?.length <= slidesToShow;

    setShowArrows(!isFewerItems);
  }, [children]);

  const settings = {
    slidesToShow: 5,
    infinite: children.length > 5,
    arrows: showArrows,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          infinite: children.length > 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          infinite: children.length > 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          infinite: children.length > 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <VertContainer fluid className="margin-bottom-big">
      <VertContainer data-testid="vert-box-showcase" className="vert-box-showcase margin-bottom-regular" spacingX="regular">
        <Row justify="center" align="middle" className="vert-box-showcase-title padding-x-extra-small" gutter={8}>
          <Col flex="auto" className="vert-box-showcase-title-label">
            <MediaQuery maxWidth={768}>
              <VertTypography.Title level={2} className="margin-bottom-none">{mobileTitle}</VertTypography.Title>
            </MediaQuery>
            <MediaQuery minWidth={769}>
              <VertTypography.Title level={2} className="margin-bottom-none">{title}</VertTypography.Title>
            </MediaQuery>

          </Col>
          {
            !hideShowAll &&
            <Col flex="none" className="vert-box-showcase-title-button">
              <VertButton path={`/showcase/?identifier=${identifier}&type=${type}`} type="link" spacing="none" size="small" className="color-detached">
                Mostrar todos
              </VertButton>
            </Col>
          }
        </Row>
      </VertContainer>
      <VertContainer fluid className="vert-box-showcase vert-bg-light-lighter padding-y-regular">
        <VertContainer spacingX="regular">
            <div className="vert-showcase-wrapper">
              <VertCarousel {...settings}>{children}</VertCarousel>
            </div>
        </VertContainer>
      </VertContainer>
    </VertContainer>
  );
};
ShowcaseVoucherWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

// SHOCASE VOUCHERS CARDS

const ShowcaseVouchersCards = (showcaseItems, showcaseName, sliceItems = 5) => {
  let items = [];
  if (!showcaseItems?.isLoading && showcaseItems?.products) {
    const productArray = Object.values(showcaseItems.products);

    items = productArray.slice(0, sliceItems).map((item, index) => {
      const {
        sku, originalId, name, imageUrl, vendor: { name: vendorName, id: vendorId },
      } = item;
      const propsCards = {
        sku,
        originalId,
        hasExtractValue: false,
        name,
        imageUrl,
        productUrl: `/product/${sku}`,
        vendorName,
        vendorId,
        colProps: {
          className: 'padding-x-extra-small',
        },
        showcaseName
      };
      return (
        <ShowcaseCard key={index} {...propsCards} />
      );
    });
  }
  return items;
};

// SHOCASE VOUCHER
const ShowcaseVoucher = ({ ...props }) => {
  const { type, identifier, className } = props;

  const ShowcaseVoucherReducer = useSelector(({ Showcase: data }) => data);
  const showcaseState = getShowcaseState(ShowcaseVoucherReducer, type, identifier);

  const showcaseItems = ShowcaseVouchersCards(showcaseState, stringToSlug(type + '' + identifier));
  return (
    <PipeProvider
      apiSymbols={[{
        symbol: 'FETCH_SHOWCASE',
        alias: (`${type}-${identifier}`),
        payload: {
          showcaseType: (type),
          identifier,
        },
      }]}
      loadingComponent={
        <div className="col-12"></div>
      }
    >
      <>
        {
          showcaseItems.length > 0
            ? (
              <ShowcaseVoucherWrapper hideShowAll={true} {...showcaseState} type={type} identifier={identifier} className={className}>
                {showcaseItems}
              </ShowcaseVoucherWrapper>
            )
            : ''
        }
      </>
    </PipeProvider>
  );
};
ShowcaseVoucher.propTypes = {
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  identifier: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ShowcaseVoucher;
